import axios from 'axios';
import { PARTICIPANT_FILTERING_API_URL } from 'appenv';

const defaultFilterOptions = {
  majorProductHandled: [],
  nob: [],
  businessRegion: [],
  country: [],
};

function fetchParticipantsByCriteria(keyWord = '', limit = 20, lastCursor = '', filterOptions = defaultFilterOptions, domain = '', roles = []) {
  const {
    majorProductHandled,
    nob,
    businessRegion,
    country,
  } = filterOptions;

  return axios({
    method: 'post',
    url: PARTICIPANT_FILTERING_API_URL,
    data: {
      cursor: lastCursor,
      limit,
      searchKeyword: keyWord,
      majorProductHandled,
      nob,
      businessRegion,
      domain,
      country,
      roles,
    },
  }).then((result) => result.data);
}

export default fetchParticipantsByCriteria;
